/* jscpd:ignore-start */
import { fetchFromVolatileServer } from "../../utils/fetchFromVolatileServer";
import { getServiceURL } from "../../utils/url";
import { handleJSONResponse } from "./utils/response-handler";

export const uploadImage = (file: File, locale?: string) => {
  const formdata = new FormData();
  formdata.append("image", file, file.name);

  const url = `${getServiceURL(locale)}/image`;
  return fetchFromVolatileServer(`${url}`, {
    method: "POST",
    body: formdata,
    credentials: "include",
    redirect: "follow",
  })
    .then(handleJSONResponse)
    .catch((err) => {
      console.error("Response not ok for", url, err.status);
      throw new Error("Response not ok");
    });
};

export const getImage = async (
  path: string,
  cookie?: string,
  locale?: string,
) => {
  const ssrCookie = cookie ? { Cookie: cookie } : undefined;

  const url = `${getServiceURL(locale)}/image/${path}`;
  return fetchFromVolatileServer(`${url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...ssrCookie,
    },
    credentials: "include",
  })
    .then(handleJSONResponse)
    .catch((err) => {
      console.error("Response not ok for", url, err.status);
      throw new Error("Response not ok");
    });
};

export const removeImage = (path: string, locale?: string) => {
  // TODO: If used separately, add a catch block
  return fetchFromVolatileServer(`${getServiceURL(locale)}/image/${path}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};
/* jscpd:ignore-end */
